import Cookie from '/app/utils/cookie';
import { api } from '/app/plugins/services';

const COOKIE = 'notification_token';
const TTL_DAYS = 30;

// Deduplicates concurrent fetches: several private channels can ask for the
// token in the same tick.
let inflight = null;

const fetchToken = () => {
    if (inflight) return inflight;

    inflight = api.auth.notification()
        .then(({ data }) => {
            Cookie.set(COOKIE, data.notification_token, true, TTL_DAYS);

            return data.notification_token;
        })
        .finally(() => {
            inflight = null;
        });

    return inflight;
};

/**
 * Pusher authorises private/presence channels with the notification token,
 * read from a shared cookie by the auth headers in `plugins/pusher`.
 *
 * Subscribing before the token lands sends `Bearer undefined` to the auth
 * endpoint, and Pusher never retries a rejected authorisation — the channel
 * stays dead until a reload. Every consumer goes through `ensure()` so the
 * fetch happens once and callers wait for it.
 */
export const ensureNotificationToken = () => {
    const cached = Cookie.get(COOKIE);

    return cached ? Promise.resolve(cached) : fetchToken();
};

/**
 * Discard the current token and fetch a new one. Used when Pusher rejects an
 * authorisation, which means the cookie outlived the token behind it.
 */
export const refreshNotificationToken = () => {
    Cookie.delete(COOKIE, true);

    return fetchToken();
};
